import type { RemoveLiquidityControllerResult } from '@/features/liquidity/useRemoveLiquidityController'

import { resolveLiquidityMobileScreen } from './mobile/useLiquidityMobileScreen'

/** Flujo UI Nutrimatic para retirar liquidez. */
export function useLiquidityRemoveNutrimaticFlow(controller: RemoveLiquidityControllerResult) {
  const screen = resolveLiquidityMobileScreen({
    txHash: controller.txHash,
    walletErrorMessage: controller.walletErrorMessage,
    showConfirm: controller.showConfirm,
    attemptingTxn: controller.attemptingTxn,
  })

  return { screen }
}
